import React from 'react'
import isFunction from 'lodash/fp/isFunction'
import { IBodyCell, IBodyRow } from './Types'

interface IBodyCellProps {
  cell: IBodyCell
  row: IBodyRow
}

function BodyCell(props: IBodyCellProps) {
  const { cell, row } = props

  const Component = cell.cellComponent

  return (
    <td style={{ opacity: cell.visible === false ? 0 : 1 }}>
      {isFunction(cell.content) ? cell.content(row, cell) : <Component content={cell.content} />}
    </td>
  )
}

export default React.memo(BodyCell)
